/**
 * Enum for external platform api.
 * @readonly
 * @enum {String} ExternalPlatformApiEnum
 */

const ExternalPlatformApiEnum = {
  EFOOD  : 'efood',
  BOX    : 'box',
  WOLT   : 'wolt',
  FOODY  : 'foody',
  FAGI   : 'fagi',
  GETFOOD: 'getfood'
}

export default ExternalPlatformApiEnum
